import { log } from '@ms-ows/logging'

let count = 0
const date = Date.now()
export const generateId = () => `MS-OWS-id-${date}-${++count}`

export const addWindowEventListener = (
  eventType: string,
  callback: EventListenerOrEventListenerObject
) => {
  if (window) {
    window.addEventListener(eventType, callback)
  }
}

export const removeWindowEventListener = (
  eventType: string,
  callback: EventListenerOrEventListenerObject
) => {
  if (window) {
    window.removeEventListener(eventType, callback)
  }
}

export const fetchURL = (
  urlType: string,
  url: string,
  options?: RequestInit
) => {
  if (!url) {
    log.error(0x2381781f /* tag_96x65 */, 'invalid url')

    return
  }

  if (!window || !window.fetch) {
    log.error(0x23817820 /* tag_96x66 */, 'fetch not available')

    return
  }

  window
    .fetch(url, options)
    .then(response => {
      if (!response.ok) {
        log.error(
          0x23810059 /* tag_96qbz */,
          `fetching url was not successful with status ${response.status}`
        )
      }
    })
    .catch(e =>
      log.error(
        0x23817821 /* tag_96x67 */,
        `error fetching url ${urlType}`,
        // tslint:disable-next-line: no-unsafe-any
        e && e.message
      )
    )
}

export function isValue<T>(val: T | null | undefined): val is T {
  return val !== null && val !== undefined
}

export function isIE() {
  return (
    window &&
    window.navigator &&
    (window.navigator.userAgent.indexOf('MSIE') !== -1 ||
      window.navigator.appVersion.indexOf('Trident/') !== -1)
  )
}

export const loadSingleScript = async (url: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const currentScriptTag = document.querySelector(`script[src="${url}"]`)
    if (!currentScriptTag) {
      const scriptTag = document.createElement('script')
      scriptTag.src = url
      scriptTag.onload = () => resolve(url)
      scriptTag.onerror = (
        _event: Event | string,
        source?: string,
        lineno?: number,
        colno?: number,
        error?: Error
      ) => {
        scriptTag.remove()
        const errorMessage = error && error.stack
        log.error(
          0x236d5005 /* tag_91vaf */,
          `error loading script ${source}, ${lineno}, ${colno}, ${errorMessage}`
        )

        reject(null)
      }

      document.head.appendChild(scriptTag)
    } else {
      resolve(url)
    }
  })
}

export const loadScripts = async (urls: string | string[]): Promise<{}> => {
  return Array.isArray(urls)
    ? Promise.all(urls.map(loadSingleScript))
    : loadSingleScript(urls)
}
